import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '../stores/authStore'

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/LoginPage.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/HomePage.vue'),
    meta: { breadcrumb: 'breadcrumb.home', requiresAuth: true }
  },
  {
    path: '/users',
    name: 'Users',
    component: () => import('../views/UsersPage.vue'),
    meta: { breadcrumb: 'breadcrumb.users', requiresAuth: true }
  },
  {
    path: '/trust-passport',
    name: 'TrustPassport',
    component: () => import('../views/TrustPassportPage.vue'),
    meta: { breadcrumb: 'breadcrumb.passport', requiresAuth: true }
  },
  {
    path: '/settings',
    name: 'Settings',
    component: () => import('../views/SettingsPage.vue'),
    meta: { breadcrumb: 'breadcrumb.settings', requiresAuth: true }
  },
  {
    path: '/activities',
    name: 'Activities',
    component: () => import('../views/ActivityPage.vue'),
    meta: { breadcrumb: 'breadcrumb.activities', requiresAuth: true }
  },
  {
    path: '/knowledge-base',
    name: 'KnowledgeBase',
    component: () => import('../views/KnowledgeBasePage.vue'),
    meta: { breadcrumb: 'kb.title', requiresAuth: true }
  },
  {
    path: '/videos',
    name: 'VideoLibrary',
    component: () => import('../views/VideoLibraryPage/VideoLibrary.vue'),
    meta: { breadcrumb: 'lib.videos_title', requiresAuth: false }
  },
  {
    path: '/video/:id',
    name: 'VideoDetail',
    component: () => import('../views/VideoLibraryPage/VideoLibrary.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/project/:hashid',
    name: 'ProjectDetail',
    component: () => import('../views/ProjectDetailPage.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/legal',
    name: 'LegalNotice',
    component: () => import('../views/LegalNoticePage.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/terms',
    name: 'TermsOfService',
    component: () => import('../views/TermsOfServicePage.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/privacy',
    name: 'PrivacyPolicy',
    component: () => import('../views/PrivacyPolicyPage.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    redirect: '/'
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  const authStore = useAuthStore()

  // Initialize from localStorage on first load
  if (!authStore.user && !authStore.userEmail) {
    authStore.initializeFromStorage()
  }

  const requiresAuth = to.meta.requiresAuth !== false

  if (requiresAuth && !authStore.isAuthenticated) {
    next('/login')
  } else if (to.name === 'Login' && authStore.isAuthenticated) {
    next('/')
  } else {
    next()
  }
})

export default router
